<template>
  <v-card v-if="items">
    <v-card-title>
      <span class="table-card-title">Resultado por loja</span>
      <v-spacer />
      <export-data :data-fetcher="getDataToExport" filename="resultados_por_loja" ghost />
    </v-card-title>
    <v-data-table
      v-model="selectedInternalItems"
      :items="items"
      :loading="loading"
      :headers="headers"
      hide-default-footer
      disable-pagination
      no-data-text="Não há dados nesta campanha"
    >
      <template v-slot:[`item.revenue`]="{ item }">
        {{ setCurrencyValue(item.revenue) }}
      </template>
      <template v-slot:[`item.discounts`]="{ item }">
        {{ setCurrencyValue(item.discounts * (item.discounts >= 0 ? 1 : -1)) }}
      </template>
      <template v-slot:[`item.tickets`]="{ item }">
        {{ item.tickets }}
      </template>
      <template v-slot:[`item.averageTicket`]="{ item }">
        {{ setCurrencyValue(item.averageTicket) }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { localeString } from '@/config/helpers.js'
import ExportData from '@/components/export-data/ExportData.vue'
import { couponDiscount } from '../../../mixins/coupon-discount'

export default {
  name: 'ResultsUnitsTable',
  components: {
    ExportData,
  },
  mixins: [couponDiscount],

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    selectedInternalItems: [],
  }),
  computed: {
    headers() {
      const headers = [
        {
          text: 'Loja',
          value: 'unit',
          width: '20%',
        },
        {
          text: 'Faturamento',
          value: 'revenue',
          width: '20%',
        },
        {
          text: 'Desconto concedido',
          value: 'discounts',
          width: '20%',
        },
        {
          text: 'Cupons de desconto',
          value: 'tickets',
          width: '20%',
        },
        {
          text: 'Ticket médio',
          value: 'averageTicket',
          width: '20%',
        },
      ]
      return headers
    },
    items() {
      return this.metrics
        ? this.metrics?.unitMetrics?.table.map((metric) => {
            return {
              unit: metric?.unit?.name,
              revenue: metric?.revenue,
              discounts: metric?.discounts,
              tickets: metric?.tickets,
              averageTicket: metric?.averageTicket,
            }
          })
        : []
    },
  },
  methods: {
    localeString,
    setCurrencyValue(value) {
      return `R$ ${this.localeString(value, 2)}`
    },
    getDataToExport() {
      const headers = this.headers.map((header) => header.text)
      const rows = this.items.map((item) =>
        this.headers.map((header) => {
          if (header.value.includes('.')) {
            const attrs = header.value.split('.')
            const rowType = typeof item[attrs[0]][attrs[1]]
            return rowType === 'number'
              ? this.localeString(item[attrs[0]][attrs[1]] < 0 ? item[attrs[0]][attrs[1]] * -1 : item[attrs[0]][attrs[1]], 2)
              : item[attrs[0]][attrs[1]]
          }
          const rowType = typeof item[header.value]

          return rowType === 'number' ? this.localeString(item[header.value] < 0 ? item[header.value] * -1 : item[header.value], 2) : item[header.value]
        })
      )
      return { headers, rows }
    },
  },
}
</script>
